<ul *ngIf="view$ | async as view">
  <li *ngFor="let link of view?.links; trackBy: trackByLink">
    <i
      [floSvg]="link.svg_on"
      [hidden]="link.svg !== link.svg_on"
      (click)="_selectionChanged(link.count)"
      class="camera-icon camera-icon-active"
      data-test="multi-view"
    ></i>
    <i
      floAnalytics
      tagName="Player Control"
      [analyticsProperties]="link.analyticProps"
      events="click"
      [floSvg]="link.svg_off"
      [hidden]="link.svg !== link.svg_off"
      (click)="_selectionChanged(link.count)"
      class="camera-icon"
    ></i>
  </li>
</ul>
